webpackJsonp([10,8],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(538);
	__webpack_require__(229);
	module.exports = __webpack_require__(222);


/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(23);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(207);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _app = __webpack_require__(228);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _getters = __webpack_require__(227);
	
	var _getters2 = _interopRequireDefault(_getters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var store = new _vuex2.default.Store({
	  modules: {
	    app: _app2.default
	  },
	  getters: _getters2.default
	});
	
	exports.default = store;

/***/ }),

/***/ 203:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 208:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  environment: 'online',
	  api: {
	    url: 'https://api.megaovip.com',
	
	    websocket: 'ws://api.megaovip.com:9589'
	  }
	};

/***/ }),

/***/ 209:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      isShow: true,
	      activeIndex: 1,
	      headerStatus: true,
	      next_page: false,
	      timer: null
	    };
	  },
	  created: function created() {
	    var that = this;
	
	    tools.vue.mixin({
	      methods: {
	        toUrl: function toUrl(url, val) {
	          tools.router.push({ path: url, query: val });
	        }
	      }
	    });
	  },
	
	  name: "app",
	  watch: {
	    $route: "isLinkChange"
	  },
	  methods: {
	    init: function init() {
	      var that = this;
	
	      var t = document.documentElement.scrollTop || document.body.scrollTop;
	
	      window.onscroll = function () {
	        var winTop = document.documentElement.scrollTop || document.body.scrollTop;
	        var menTop = 170;
	        if (winTop >= menTop) {
	          that.headerStatus = false;
	        } else {
	          that.headerStatus = true;
	        }
	        if (winTop > window.innerHeight) {
	          that.next_page = true;
	        } else {
	          that.next_page = false;
	        }
	      };
	    },
	
	    isLinkChange: function isLinkChange() {
	      var that = this;
	
	
	      if (!that.isHavePage()) {
	        return;
	      }
	
	      if (that.$route.path == "/shopkeeper") {
	        that.activeIndex = 2;
	      } else if (that.$route.path == "/about") {
	        that.activeIndex = 3;
	      } else if (that.$route.path == "/download") {
	        that.activeIndex = 4;
	      } else {
	        that.activeIndex = 1;
	      }
	
	
	      that.isShow = true;
	    },
	
	    isHavePage: function isHavePage() {
	      console.log(this.$route);
	      if (this.$route.path == "/") {
	        return true;
	      }
	
	      if (this.$route.path == "/404") {
	        this.isShow = true;
	        return false;
	      }
	
	      if (this.$route.path == "/register") {
	        this.isShow = true;
	        return false;
	      }
	
	      if (this.$route.matched.length < 1) {
	        tools.router.push("/404");
	        return false;
	      }
	      if (this.$route.query.type) {
	        document.documentElement.scrollTop = document.body.scrollTop = 700;
	      } else {
	        document.documentElement.scrollTop = document.body.scrollTop = 0;
	      }
	
	      this.isfullScreen = false;
	      return true;
	    },
	
	    navBlock: function navBlock(type) {
	      this.isNavBlock = type;
	    },
	    setTop: function setTop() {
	      var that = this;
	
	      var oTop = document.body.scrollTop || document.documentElement.scrollTop;
	      if (oTop > 0) {
	        document.body.scrollTop = document.documentElement.scrollTop = oTop - 50;
	        that.setTop();
	      } else {}
	    },
	
	    toUrl: function toUrl(url, val) {
	      tools.router.push({ path: url, query: val });
	    }
	  },
	  components: {},
	  beforeCreate: function beforeCreate() {},
	  mounted: function mounted() {
	    this.isHavePage();
	    this.init();
	  }
	};

/***/ }),

/***/ 218:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var is_init = true;
	var array = [],
	    num = 0;
	
	exports.default = {
	    data: [{
	        errcode: 'AUTHORIZATION_INVALID',
	        prompt: '',
	        url: '',
	        fun: function fun(res) {
	            array.push(res.option);
	
	            if (is_init) {
	                tools.cache.del('Authorization');
	                getToken(array);
	            }
	
	            is_init = false;
	
	            function getToken(array) {
	                tools.ajax({
	                    url: '/api/init',
	                    headers: {
	                        'X-ISSIGN': 1
	                    },
	                    isLoading: true,
	                    successFun: function successFun(res) {
	                        tools.cache.set('Authorization', res.token);
	                        tools.cache.set('is_sign', res.is_sign);
	                        tools.cache.set('sk', res.sk);
	                        next(array);
	                    },
	                    errorFun: function errorFun(error) {
	                        log.error('获取签名失败');
	                    },
	                    type: 'GET'
	                });
	            };
	
	            function next(dataArr) {
	                for (var i = 0; i < dataArr.length; i++) {
	                    num++;
	                    tools.ajax(dataArr[i]);
	                }
	                if (num === dataArr.length) {
	                    is_init = true;
	                    array = [];
	                    num = 0;
	                }
	            }
	        }
	    }, {
	        errcode: 'NO LOGIN',
	        prompt: '你还没有登录或登录超时,请登录...',
	        url: '',
	        fun: function fun() {
	            window.tools.cache.set('isLogin', 0);
	        }
	    }]
	
	};

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (to, from, next) {
	    _main2.default.check(next, {
	        type: false
	    }, to, from);
	};
	
	var _main = __webpack_require__(220);
	
	var _main2 = _interopRequireDefault(_main);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _messageBox = __webpack_require__(539);
	
	var _messageBox2 = _interopRequireDefault(_messageBox);
	
	var _base = __webpack_require__(203);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _messageBox3 = __webpack_require__(522);
	
	var _messageBox4 = _interopRequireDefault(_messageBox3);
	
	var _regenerator = __webpack_require__(238);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(236);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _typeof2 = __webpack_require__(237);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _assign = __webpack_require__(232);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _nologin = __webpack_require__(221);
	
	var _nologin2 = _interopRequireDefault(_nologin);
	
	var _store = __webpack_require__(140);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _timers = __webpack_require__(309);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var auth = {
		check: function check(next, option, to, from) {
			var _this = this;
	
			return new _timers.Promise(function (resolve, reject) {
				var asyncFun = function () {
					var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(dataArr) {
						var i;
						return _regenerator2.default.wrap(function _callee$(_context) {
							while (1) {
								switch (_context.prev = _context.next) {
									case 0:
										i = 0;
	
									case 1:
										if (!(i < dataArr.length)) {
											_context.next = 16;
											break;
										}
	
										if (!(dataArr[i] === 'auth')) {
											_context.next = 7;
											break;
										}
	
										_context.next = 5;
										return promiseFiy(auth);
	
									case 5:
										_context.next = 13;
										break;
	
									case 7:
										if (!(dataArr[i] === 'login')) {
											_context.next = 12;
											break;
										}
	
										_context.next = 10;
										return promiseFiy(login);
	
									case 10:
										_context.next = 13;
										break;
	
									case 12:
										reject('请传入正确参数(type)，授权：auth，登录：login');
	
									case 13:
										i++;
										_context.next = 1;
										break;
	
									case 16:
									case 'end':
										return _context.stop();
								}
							}
						}, _callee, this);
					}));
	
					return function asyncFun(_x) {
						return _ref.apply(this, arguments);
					};
				}();
	
				var auth = function () {
					var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(kidResolve) {
						return _regenerator2.default.wrap(function _callee2$(_context2) {
							while (1) {
								switch (_context2.prev = _context2.next) {
									case 0:
	
										if (window.mainInit && data.getLoginState) {
											window.mainInit = 0;
											that.isLogin(data.getLoginState.url, next, data, to, from, that.canAuth, resolve, kidResolve);
										} else if (!window.mainInit && data.getLoginState && Number(tools.cache.get('isAuth')) === 2) {
											that.isLogin(data.getLoginState.url, next, data, to, from, that.canAuth, resolve, kidResolve);
										} else if (window.mainInit && !data.getLoginState && !Number(tools.cache.get('isAuth'))) {
												window.mainInit = 0;
												that.canAuth({ status: true }, next, data, to, from, resolve, kidResolve);
											} else if (window.mainInit && !data.getLoginState && Number(tools.cache.get('isAuth')) === 2) {
													window.mainInit = 0;
													tools.cache.set('isAuth', 1);
													resolve(that.authData);
												} else if (!window.mainInit && !Number(tools.cache.get('isAuth'))) {
														that.canAuth({ status: true }, next, data, to, from, resolve, kidResolve);
													} else if (!window.mainInit && data.getLoginState && Number(tools.cache.get('isAuth')) === 1 && data.isRepeat === 1) {
															resolve(that.authData);
														} else {
															if ((0, _typeof3.default)(data.type) === 'object' && data.type instanceof Array && data.type.length > 1) {
																kidResolve();
															} else {
																typeof next === 'function' ? next() : null;
															}
														}
	
									case 1:
									case 'end':
										return _context2.stop();
								}
							}
						}, _callee2, this);
					}));
	
					return function auth(_x2) {
						return _ref2.apply(this, arguments);
					};
				}();
	
				var that = _this,
				    data = {
					isRepeat: 0,
					type: 0,
					getLoginState: false,
					authUrl: '/api/wechat/auth',
					redirectUrl: false
				};
	
				data = (0, _assign2.default)(data, option);
	
				if (!option) {
					next();
				} else {
					if (tools.isEmpty(tools.cache.get('Authorization')) && window.canauthinit === 1) {
						that.getSign(next, data, to, from);
					} else {
						if (!data.type) {
							typeof next === 'function' ? next() : null;
						} else if ((0, _typeof3.default)(data.type) === 'object' && data.type instanceof Array && data.type.length === 0) {
							typeof next === 'function' ? next() : null;
						} else if (data.type === 'auth') {
								auth();
							} else if (data.type === 'login') {
									login();
								} else if ((0, _typeof3.default)(data.type) === 'object' && data.type instanceof Array && data.type.length > 0) {
										asyncFun(data.type).catch(function (e) {
											log.error(e);
										});
									}
					}
				}
	
				function promiseFiy(fun) {
					return new _timers.Promise(function (kidResolve, kidReject) {
						fun(kidResolve);
					});
				}
	
				function login(kidResolve) {
					if (tools.url.params('usertest') && config.environment === 'debug') {
						typeof next === 'function' ? next() : null;
					} else if ((0, _nologin2.default)(to.path) || data.redirectUrl === to.path) {
						typeof next === 'function' ? next() : null;
					} else if (window.mainInit && data.getLoginState.url) {
							window.mainInit = 0;
							that.isLogin(data.getLoginState.url, next, data, to, from, that.canLogin, resolve, kidResolve);
						} else if (window.mainInit && Number(tools.cache.get('isLogin')) === 0) {
							window.mainInit = 0;
							tools.router.replace({ path: data.redirectUrl, query: { callback: to.fullPath } });
						} else if (window.mainInit && data.getLoginState && Number(tools.cache.get('isLogin')) === 1) {
							window.mainInit = 0;
							resolve(that.authData);
						} else if (window.mainInit && !data.getLoginState && Number(tools.cache.get('isLogin')) === 1) {
							window.mainInit = 0;
							typeof next === 'function' ? next() : null;
						} else if (!window.mainInit && Number(tools.cache.get('isLogin')) === 0 && data.redirectUrl) {
								tools.cache.set('isLogin', 0);
								tools.router.replace({ path: data.redirectUrl, query: { callback: to.fullPath } });
							} else {
								typeof next === 'function' ? next() : null;
							}
				}
			});
		},
		canLogin: function canLogin(res, next, option, to, from, resolve, kidResolve) {
			var data = res.data,
			    callback = option.callback;
			if (res.status && data && !option.redirectUrl) {
				log.error('请传入参数：redirectUrl');
			} else if (res.status && data && option.redirectUrl && !option.getLoginState.isLogin) {
				log.error('请传入参数：getLoginState 中的 isLogin');
			} else if (res.status && data && data[option.getLoginState.isLogin]) {
				tools.cache.set('isLogin', 1);
				kidResolve();
				typeof resolve === 'function' ? resolve(res) : null;
			} else if (res.status && data && !data[option.getLoginState.isLogin]) {
				tools.cache.set('isLogin', 0);
				tools.router.replace({ path: option.redirectUrl, query: { callback: to.fullPath } });
			} else {
				typeof resolve === 'function' ? resolve({ status: false, message: '登录异常' }) : null;
			}
		},
		canAuth: function canAuth(res, next, option, to, from, resolve, kidResolve) {
			var that = this,
			    data = res.data;
	
			if (res.status && data && data[option.getLoginState.isAuth]) {
				tools.cache.set('isAuth', 1);
				kidResolve();
				typeof resolve === 'function' ? resolve(res) : null;
			} else if (res.status && data && !data[option.getLoginState.isAuth]) {
				tools.cache.set('isAuth', 2);
				goAuth();
			} else if (!res.status && !data || !res.status && data && data.length === 0) {
				tools.cache.set('isAuth', 2);
				goAuth();
			} else if (res.status && !data || res.status && data && data.length === 0) {
				tools.cache.set('isAuth', 2);
				goAuth();
			} else {
				typeof resolve === 'function' ? resolve({ status: false, message: '登录异常' }) : null;
			}
	
			function goAuth() {
				var callbackUrl = location.origin + to.fullPath;
	
				var url = window.config.api.url + option.authUrl + '?callback=' + encodeURIComponent(callbackUrl) + '&token=' + tools.cache.get('Authorization') + '&type=' + 'mp';
	
				if (!tools.isEmpty(tools.url.params('usertest'))) {
					url += '&usertest=' + tools.url.params('usertest');
				}
	
				window.location.href = url;
			}
		},
		getSign: function getSign(next, option, to, from) {
			var that = this;
			window.canauthinit = 0;
			tools.alert.loading();
			tools.ajax({
				url: '/api/init',
				ajaxData: {},
				successFun: function successFun(res) {
					tools.cache.set('Authorization', res.token);
					window.canauthinit = 1;
					tools.alert.closeLoading();
					if (typeof next == 'function') {
						that.check(next, option, to, from);
					}
				},
				errorFun: function errorFun(error) {
					log.error('获取签名失败');
					window.canauthinit = 1;
				},
				type: 'GET'
			});
		},
	
		isLogin: function isLogin(url, next, option, to, from, callback, resolve, kidResolve) {
			var that = this;
	
			tools.alert.loading();
			tools.ajax({
				url: url,
				ajaxData: {},
				successFun: function successFun(res) {
					tools.alert.closeLoading();
					that.authData = res.data;
					typeof callback === 'function' ? callback(res, next, option, to, from, resolve, kidResolve) : null;
				},
				errorFun: function errorFun(error) {
					log.debug('获取登录状态失败, 请查看接口');
					var error_msg = '服务器异常,尝试刷新';
					if (error && error.error_msg) {
						error_msg = error.error_msg;
					}
					_messageBox4.default.alert(error_msg).then(function (action) {
						window.location.reload();
					});
	
					tools.cache.del('isLogin');
					tools.cache.del('isAuth');
				},
				type: 'GET'
			});
		},
	
		authData: {
			status: true
		}
	};
	
	exports.default = auth;

/***/ }),

/***/ 221:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var list = ['/login', '/register', '/index', '/', '/goods/classification', '/goods/list', '/goods/details', '/login_old', '/authorization_error', '/forget', '/agreement', '/article/details'];
	
	var isUrl = function isUrl(url, type) {
		var that = this,
		    sym = '==',
		    noLoginUrls = '';
	
		if (type) {
			sym = type;
		}
	
		for (var i = 0; i < list.length; i++) {
	
			if (i == 0) {
				noLoginUrls += '"' + url + '"' + sym + '"' + list[i] + '"';
			} else if (i == list.length - 1) {
				noLoginUrls += '||"' + url + '"' + sym + '"' + list[i] + '"';
			} else {
				noLoginUrls += '||"' + url + '"' + sym + '"' + list[i] + '"';
			}
		}
	
		return eval(noLoginUrls);
	};
	
	exports.default = isUrl;

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _stringify = __webpack_require__(231);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _route = __webpack_require__(555);
	
	var _route2 = _interopRequireDefault(_route);
	
	var _alert = __webpack_require__(552);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _log = __webpack_require__(554);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _tools = __webpack_require__(204);
	
	var _tools2 = _interopRequireDefault(_tools);
	
	var _option = __webpack_require__(540);
	
	var _option2 = _interopRequireDefault(_option);
	
	var _option3 = __webpack_require__(525);
	
	var _option4 = _interopRequireDefault(_option3);
	
	var _select = __webpack_require__(541);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _base = __webpack_require__(203);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _select3 = __webpack_require__(527);
	
	var _select4 = _interopRequireDefault(_select3);
	
	var _vue = __webpack_require__(23);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(207);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vueRouter = __webpack_require__(583);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _App = __webpack_require__(566);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _store = __webpack_require__(140);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _config = __webpack_require__(208);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _error_handle = __webpack_require__(218);
	
	var _error_handle2 = _interopRequireDefault(_error_handle);
	
	var _base3 = __webpack_require__(223);
	
	var _base4 = _interopRequireDefault(_base3);
	
	var _dynamic = __webpack_require__(224);
	
	var _dynamic2 = _interopRequireDefault(_dynamic);
	
	var _system = __webpack_require__(226);
	
	var _system2 = _interopRequireDefault(_system);
	
	var _example = __webpack_require__(225);
	
	var _example2 = _interopRequireDefault(_example);
	
	var _jquery = __webpack_require__(557);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _bluebird = __webpack_require__(242);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _index = __webpack_require__(219);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_select4.default);
	_vue2.default.use(_option4.default);
	
	var tools = _tools2.default;
	var log = _log2.default;
	var alert = _alert2.default;
	
	tools.errorData = _error_handle2.default.data;
	
	_route2.default.data.baseRoute = _base4.default;
	_route2.default.data.dynamicRoute = _dynamic2.default;
	_route2.default.data.systemRoute = _system2.default;
	_route2.default.data.exampleRoute = _example2.default;
	
	var app = window;
	
	_tools2.default.vue = _vue2.default;
	_tools2.default.alert = alert;
	app.tools = tools;
	
	app.config = _config2.default;
	app.log = log;
	app.$ = _jquery2.default;
	app.jQuery = _jquery2.default;
	app.Promise = _bluebird2.default;
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vuex2.default);
	
	var routes = _route2.default.routes();
	
	var router = new _vueRouter2.default({
	    mode: 'history',
	    routes: routes
	});
	
	if (!sessionStorage.length) {
	    localStorage.setItem('getSessionStorage', Date.now());
	}
	
	window.addEventListener('storage', function (event) {
	
	    if (event.key == 'getSessionStorage') {
	        localStorage.setItem('sessionStorage', (0, _stringify2.default)(sessionStorage));
	        localStorage.removeItem('sessionStorage');
	    } else if (event.key == 'sessionStorage' && !sessionStorage.length) {
	        var p = [];
	
	        if (event.newValue) {
	            p = JSON.parse(event.newValue);
	        }
	
	        for (var key in p) {
	            tools.cache.set(key, p[key]);
	        }
	    }
	});
	
	app.canauthinit = 1;
	
	window.mainInit = 1;
	
	app.tools.router = router;
	
	app.tools.routes = routes;
	
	window.addEventListener('load', function () {
	
	    if (navigator.appName == "Microsoft Internet Explorer" && parseInt(navigator.appVersion.split(";")[1].replace(/[ ]/g, "").replace("MSIE", "")) < 10) {
	        return;
	    }
	
	    router.beforeEach(function (to, from, next) {
	        (0, _index2.default)(to, from, next);
	    });
	
	    new _vue2.default({
	        el: '#app',
	        store: _store2.default,
	        template: '<App/>',
	        components: { App: _App2.default },
	        router: router
	    });
	});

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	     value: true
	});
	exports.default = {
	     'about': function about(resolve) {
	          return __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(571)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'download': function download(resolve) {
	          return __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(572)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	     'index': function index(resolve) {
	          return __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(206)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	
	     'shopkeeper': function shopkeeper(resolve) {
	          return __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(573)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     },
	
	     '/': function _(resolve) {
	          return __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(206)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	     }
	};

/***/ }),

/***/ 224:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {};

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'example/table': function exampleTable(resolve) {
	        return __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(570)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    'example/form': function exampleForm(resolve) {
	        return __webpack_require__.e/* require */(6, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(568)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    'example/socket': function exampleSocket(resolve) {
	        return __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(569)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	};

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '404': function _(resolve) {
	        return __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(567)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	};

/***/ }),

/***/ 227:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getters = {
	  test: function test(state) {
	    return state.app.test;
	  }
	};
	exports.default = getters;

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tools = __webpack_require__(204);
	
	var _tools2 = _interopRequireDefault(_tools);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var app = {
	  state: {
	    name: _tools2.default.cache.get('nickname') || '',
	    headimg: _tools2.default.cache.get('headimg') || ''
	  },
	  mutations: {
	    GET_INFO: function GET_INFO(state) {
	      state.name = _tools2.default.cache.get('nickname');
	      state.headimg = _tools2.default.cache.get('headimg');
	    }
	  },
	  actions: {
	    updateInfo: function updateInfo(_ref) {
	      var commit = _ref.commit;
	
	      commit('GET_INFO');
	    }
	  }
	};
	
	exports.default = app;

/***/ }),

/***/ 539:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 541:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(547)
	
	var Component = __webpack_require__(36)(
	  /* script */
	  __webpack_require__(209),
	  /* template */
	  __webpack_require__(578),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 578:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isShow),
	      expression: "isShow"
	    }],
	    class: {
	      pt170: _vm.headerStatus
	    },
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('div', {
	    staticClass: "app-header",
	    class: {
	      active: !_vm.headerStatus
	    }
	  }, [_c('div', [_c('img', {
	    staticClass: "logo",
	    attrs: {
	      "src": ("/static/images/" + (_vm.headerStatus?'logo1':'logo') + ".png"),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "header-nav"
	  }, [_c('span', {
	    class: {
	      active: _vm.activeIndex == 1
	    },
	    on: {
	      "click": function($event) {
	        _vm.toUrl('/');
	        _vm.activeIndex = 1
	      }
	    }
	  }, [_vm._v("首页")]), _vm._v(" "), _c('span', {
	    class: {
	      active: _vm.activeIndex == 2
	    },
	    on: {
	      "click": function($event) {
	        _vm.toUrl('/shopkeeper');
	        _vm.activeIndex = 2
	      }
	    }
	  }, [_vm._v("成为店主")]), _vm._v(" "), _c('span', {
	    class: {
	      active: _vm.activeIndex == 3
	    },
	    on: {
	      "click": function($event) {
	        _vm.toUrl('/about');
	        _vm.activeIndex = 3
	      }
	    }
	  }, [_vm._v("关于美购")]), _vm._v(" "), _c('span', {
	    class: {
	      active: _vm.activeIndex == 4
	    },
	    on: {
	      "click": function($event) {
	        _vm.toUrl('/download');
	        _vm.activeIndex = 4
	      }
	    }
	  }, [_vm._v("APP下载")]), _vm._v(" "), _c('p', [_vm._v("客服热线：020-3992-1805")])])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('div', {
	    staticClass: "app-footer",
	    class: {
	      gray: _vm.activeIndex == 2
	    }
	  }, [_c('div', {
	    staticClass: "setTop",
	    on: {
	      "click": function($event) {
	        return _vm.setTop()
	      }
	    }
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.next_page),
	      expression: "next_page"
	    }],
	    staticClass: "app-right-nav"
	  }, [_c('div', {
	    staticClass: "div"
	  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "div",
	    on: {
	      "click": function($event) {
	        return _vm.setTop()
	      }
	    }
	  })])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "footer-box"
	  }, [_c('div', {
	    staticClass: "pull-left"
	  }, [_c('img', {
	    staticClass: "footer-logo",
	    attrs: {
	      "src": "/static/images/footer_logo.png?v=1.00",
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "mt28 mb22 f20"
	  }, [_vm._v("联系我们")]), _vm._v(" "), _c('p', {
	    staticClass: "mb10"
	  }, [_c('span', [_vm._v("客服电话: 020-3992-1805 ")]), _vm._v(" "), _c('span', {
	    staticClass: "mr0"
	  }, [_vm._v("招商热线: 020-3992-1805 ")])]), _vm._v(" "), _c('p', [_vm._v("地址:广州市番禺区番禺大道北555号天安节能科技园23号楼23层")])]), _vm._v(" "), _c('div', {
	    staticClass: "code pull-right"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/images/public_number.png",
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("美购国际公众号")])]), _vm._v(" "), _c('div', {
	    staticClass: "code pull-right ml0"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/images/wechat.png",
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("美购国际官方微信")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "record-number"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://beian.miit.gov.cn",
	      "target": "_blank"
	    }
	  }, [_vm._v("粤ICP备18133614号-1")]), _vm._v("\n       COPYRIGHT 2018 MEGAOSHOP.COM ALL RIGHTS RESERVED. 美购国际 版权所有"), _c('br'), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "width": "300px",
	      "margin": "0 auto",
	      "padding": "20px 0"
	    }
	  }, [_c('a', {
	    staticStyle: {
	      "display": "inline-block",
	      "text-decoration": "none",
	      "height": "20px",
	      "line-height": "20px"
	    },
	    attrs: {
	      "target": "_blank",
	      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011302002965"
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "float": "left"
	    },
	    attrs: {
	      "src": "/static/images/record-logo.png"
	    }
	  }), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "float": "left",
	      "height": "20px",
	      "line-height": "20px",
	      "margin": "0px 0px 0px 5px",
	      "color": "#939393"
	    }
	  }, [_vm._v("粤公网安备 44011302002965号")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "div"
	  }, [_c('div', {
	    staticClass: "code"
	  }, [_c('div', {
	    staticClass: "pull-right"
	  }, [_c('div', {
	    staticClass: "img",
	    staticStyle: {
	      "background-image": "url('/static/images/public_number.png')"
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("美购国际公众号")])]), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  }, [_c('div', {
	    staticClass: "img",
	    staticStyle: {
	      "background-image": "url('/static/images/wechat.png')"
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("美购国际官方微信")])])])])
	}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.6d8fb14f05093e8f5c0f.js